import { agentTypes } from "@agent/agent-types.di";
import type { Agent, AgentFilter } from "@agent/domain/models/agent.model";
import type { AgentRepository } from "@agent/domain/repositories/agent.repository";
import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository";
import { inject, injectable } from "inversify";

@injectable()
export class AgentGetAllUseCase {
    constructor(
        @inject(agentTypes.repositories.AgentRepository)
        private readonly agentRepository: AgentRepository,
    ) {}

    async execute(agentFilter?: AgentFilter): Promise<Agent[]> {
        const agentsResult = await this.agentRepository.getAll(agentFilter);

        if (agentsResult.isErr()) {
            ToastManagerRepository.error(agentsResult.error.message);
        }

        return agentsResult.match(
            (agents) => agents,
            () => [],
        );
    }
}
